export default __webpack_public_path__ + "static/media/calendar-icon.f6b7b639.svg";